import { render, staticRenderFns } from "./MenuCardRealtime.vue?vue&type=template&id=4f8b9888&scoped=true"
import script from "./MenuCardRealtime.vue?vue&type=script&lang=js"
export * from "./MenuCardRealtime.vue?vue&type=script&lang=js"
import style0 from "./MenuCardRealtime.vue?vue&type=style&index=0&id=4f8b9888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b9888",
  null
  
)

export default component.exports